/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentQueryWorkload extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentQueryWorkload");
    }

    getFixupPrototypeFunction() { return AssessmentQueryWorkload.fixupPrototype; }

    static newInstance(model: Partial<AssessmentQueryWorkload>): AssessmentQueryWorkload {
        let obj = Object.assign(new AssessmentQueryWorkload(), model);
        AssessmentQueryWorkload.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentQueryWorkload>): AssessmentQueryWorkload {
        if (!model) return null;
        return AssessmentQueryWorkload.newInstance(<AssessmentQueryWorkload> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentQueryWorkload) {
        if (!obj) return;

        models.AssessmentQueryWorkload.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentQueryWorkload): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentQueryWorkload.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the Workload Definition
     */
    workload_ids: Array<string>;

}
